import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LabeledDropDown from "../TemplateProperties/TPDropDown";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../redux/api";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Tree from "rc-tree";
import { workflowGroupsToRcTree } from "../../utils/rctreeDataConversion";
import { SystemDataListArray } from "../../constants/constantList";
import { t } from "i18next";
import { isObject } from "lodash";
import { getShiftSelectedKeys } from "../Trees/InboundTemplateTree";
import { eachDeep } from "deepdash-es/standalone";
import { ParentScreenCtx } from "../../pages/workbench_build/WorkbenchBuild";
import SmartPasswordField from "../../commonComponents/SmartPasswordField";
import LightTooltip from '../../commonComponents/LightTooltip';

const API_ENDPOINTS = {
  callingWorkflow: api.endpoints.get_session_var_names,
  workflowSession: api.endpoints.get_session_var_names,
  accountData: api.endpoints.getAccountData,
}

const VALUE_LIST = {
  systemData: SystemDataListArray
}

const DIALOG_TITLE = {
  accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_TIT_ACCOUNT_DATA'),
  callingWorkflow: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD'),
  workflowSession: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD'),
  systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_TIT_SYSTEM_DATA'),
}

const DIALOG_DESC_SHORT = {
  accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC_ACCOUNT_DATA'),
  callingWorkflow: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC'),
  workflowSession: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC'),
  systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_DESC_SYSTEM_DATA'),
}

const DIALOG_DESC_LONG = {
  accountData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG_ACCOUNT_DATA'),
  callingWorkflow: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG'),
  workflowSession: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG'),
  systemData: t('DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD3_MSG_SYSTEM_DATA'),
}



const WorkflowSessionModal2 = ({ openModal, handleClose1, handleClose2, resetStates, selectedTemplate, valueHandler, sourceType, showSelection, previousValue, selection, handleTextFieldClick, inputType, specialPasswordField, initialMaskLength}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx)
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [actions, setActions] = useState({
    back: true,
    next: false,
    finish: false,
  });
  const { user, account } = useSelector((state) => state.queryParams);
  const leftTreeSelectedNode = useSelector((state) => state.treeData.workflow.leftTree.tree.body.selectedNode);
  const rightTreeSelectedNode = useSelector((state) => state.treeData.workflow.rightTree.tree[state.treeData.workflow.rightTree.currentTab].selectedNode);
  const [treeData, setTreeData] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [error, setError] = useState('');


  useEffect(() => {
    if (previousValue && showSelection) setValue(previousValue)
    else setValue('');

    return () => {
      setValue('');
      setSelectedValue('');
    }

  }, [previousValue])



  //RC-Tree Functions

  const iconRender = (node) => {
    return (
      <span
        className={node?.ICON_DISPLAY}
      ></span>
    );
  };

  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />;
    else return <ArrowRightIcon sx={{ color: "#666666" }} />;
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const dataToRcTree = (data, key = 'ws', parentId, parentArray = [], isTranslatedData) => {
    if (!data?.length && isObject(data) && !Object.keys(data)?.length) return [];
    if (sourceType === "callingWorkflow" || sourceType === "workflowSession") {
      return data.map((ele, idx) => {
        const newKey = `${key}-${idx}`;
        const title = ele?.text?.split(": ") || ele?.text;
        const name = ele?.localizedString || title?.[1]
        const translatedData = isTranslatedData || ele?.iconName?.toUpperCase() === "ANALYZE" || false
        parentArray.push(title?.[1] || title?.[0]);
        const obj = {
          key: newKey,
          title: ele?.text,
          ICON_DISPLAY: ele?.iconName?.toUpperCase() || '',
          children: dataToRcTree(ele?.chlid || ele?.children || [], newKey, ele?.id || parentId, parentArray, translatedData),
          data: ele?.data,
          WF_ITEM_ID: ele?.id || parentId,
          localizedString: ele?.localizedString,
          template: sourceType === "workflowSession" ? leftTreeSelectedNode?.title : selectedTemplate?.template,
          account: selectedTemplate?.account || account,
          workflowGroup: sourceType === "workflowSession" ? leftTreeSelectedNode?.workflowGroup : selectedTemplate?.workflow,
          parent: ((ele?.iconName?.toUpperCase() === "BLACK_DOT") || (ele?.iconName?.toUpperCase() === "FIELD")) ? (translatedData ? parentArray?.[parentArray?.length - 3] : parentArray?.[parentArray.length - 2]) : (title?.[1] || title?.[0]),
          ...((translatedData && parentArray.length > 1) && { condition: parentArray?.[parentArray?.length - 2] }),
        }
        parentArray.pop();
        return obj;
      })
    } else if (sourceType === "accountData") {
      return data.map((ele, idx) => {
        const newKey = `${key}-${idx}`;
        const title = Object.keys(ele)[0];
        return {
          key: newKey,
          title: title,
          ICON_DISPLAY: 'SESSION_DATA',
          data: "ACCOUNT_DATA",
          mapName: title?.split(": ")[1]
        }
      })
    } else if (sourceType === "systemData") {
      return Object.keys(data).map((ele, idx) => {
        const newKey = `${key}-${idx}`;
        const title = t(ele);
        return {
          key: newKey,
          title: title,
          ICON_DISPLAY: 'SESSION_DATA',
          data: "SYSTEM_DATA",
          mapName: ele
        }
      })
    }

  }

  const getSelectedNodes = (keys) => {
    const nodes = [];
    eachDeep(treeData, (obj) => {
      let found = false;
      keys.forEach(e => {
        if (obj?.key === e) found = true;
      })
      if (!found) return;
      else nodes.push(obj);
    })
    return nodes;
  }


  const getAllParentNode = (translatedData) => {
    const parentNodes = [];
    eachDeep(translatedData, (obj) => {
      if (obj?.key && obj?.children?.length) {
        parentNodes.push(obj.key);
      }
    });
    return parentNodes;
  };

  const handleExpand = () => {
    const parentNodeArray = getAllParentNode(treeData);
    setExpandedKeys(parentNodeArray);
  };

  const handleCollapse = () => {
    setExpandedKeys([]);
  };

  const onSelect = (keys, info) => {
    let newSelectedKeys = []
    const handleMultipleSelectOptions = () => {
      // modifier keys, including MacOS metakey.
      let kb = {
        shift: info.nativeEvent ? info.nativeEvent.shiftKey : false,
        ctrl: info.nativeEvent ? info.nativeEvent.ctrlKey : false,
        metaKey: info.nativeEvent ? info.nativeEvent.metaKey : false,
      };

      if (!kb.ctrl && !kb.shift && !kb.metaKey) {
        // if none: select single node normally.
        newSelectedKeys = [info.node.key];
      }
      else if ((kb.ctrl || kb.metaKey) && !kb.shift) {
        // if ctrl or meta, and not shift: 
        newSelectedKeys = keys.length !== 0 ? keys : [info.node.key]
      }
      if (kb.shift) {
        if (keys.length > 1) {
          newSelectedKeys = getShiftSelectedKeys(keys, treeData)
        }
      }
    }
    handleMultipleSelectOptions();
    setSelectedKeys(newSelectedKeys);

    const selectedNodes = getSelectedNodes(newSelectedKeys);
    const finalSelectedValues = [];
    selectedNodes.forEach(e => {
      if ((sourceType === "callingWorkflow" || sourceType === "workflowSession") && (e?.data || e?.ICON_DISPLAY === 'BLACK_DOT' || e?.ICON_DISPLAY === 'LOOPITEM')) {
        const dataArray = e?.data?.split("=");
        const titleArray = e?.title?.split(": ");
        
        // Special handling for loop items
        if (e?.ICON_DISPLAY === 'LOOPITEM') {
          finalSelectedValues.push({
            WF_ITEM_LOCATION: (sourceType === "callingWorkflow" && parentScreen === "workflow") ? "CWF_DATA" : "WF_DATA",
            WF_ITEM_ID: e?.WF_ITEM_ID,
            MAPNAME: "LOOP_COUNT",
            template: e?.template,
            account: e?.account,
            workflowGroup: e?.workflowGroup,
            parent: e?.parent,
            ...(e?.condition && { condition: e?.condition })
          })
        } else {
          finalSelectedValues.push({
            WF_ITEM_LOCATION: (sourceType === "callingWorkflow" && parentScreen === "workflow") ? "CWF_DATA" : dataArray?.[1] || dataArray?.[0] || e?.data,
            ...((e?.ICON_DISPLAY === "VARIABLE" && sourceType === "workflowSession") ? {} : { WF_ITEM_ID: e?.WF_ITEM_ID }),
            MAPNAME: e?.localizedString || titleArray?.[1] || titleArray?.[0] || e?.title,
            template: e?.template,
            account: e?.account,
            workflowGroup: e?.workflowGroup,
            parent: e?.parent,
            ...(e?.condition && { condition: e?.condition })
          })
        }
      } else if (["accountData", "systemData"].includes(sourceType)) {
        finalSelectedValues.push({
          type: e?.data,
          MAPNAME: sourceType === "accountData" ? e.title : e?.mapName,
        })
      }
    })
    setSelectedValue(finalSelectedValues);
    if (finalSelectedValues.length) setActions(prev => { return { ...prev, finish: true } });
    else setActions(prev => { return { back: true, next: false, finish: false, } });
  };

  useEffect(() => {
    if (openModal) {
      setError(''); // Clear any previous errors
      if (['callingWorkflow', 'accountData', 'workflowSession'].includes(sourceType)) {
        setLoading(true);

        dispatch(API_ENDPOINTS[sourceType].initiate({
          account: selectedTemplate?.account || account,
          user,
          workflow_group_name: sourceType === "workflowSession" ? leftTreeSelectedNode?.workflowGroup : selectedTemplate?.workflow,
          workflow_name: sourceType === "workflowSession" ? leftTreeSelectedNode?.title : selectedTemplate?.template,
          ...(sourceType === "workflowSession" ? { current_item_id : rightTreeSelectedNode?.ID } : {})
        }, { forceRefetch: true }))
                    .then(res => {
            if (res.data.current_state === "SUCCESS") {
              let data = [...res?.data?.data?.chlid || res?.data?.data?.children || res?.data?.data?.account_data_keys || []]
              const tree = dataToRcTree(data);
              setTreeData(tree);
            } else {
              const errorMessage = res.data?.message || 'Unknown error occurred';
              setTreeData([]);
              setError(errorMessage);
            }
           })
           .catch(error => {
             setTreeData([]);
             setError('Network error occurred. Please try again.');
           })
          .finally(() => {
            setLoading(false);
          })
      } else {
        const tree = dataToRcTree(VALUE_LIST[sourceType]);
        setTreeData(tree)
      }
    }
    setSelectedKeys([]);
    setExpandedKeys([]);
    setActions({ back: true, next: false, finish: false })
  }, [openModal])

  return (
    <Dialog
      open={openModal}
      fullWidth
      maxWidth="sm"
      sx={{ overflow: "hidden", userSelect: "none" }}
    >
      <DialogTitle className="dialog-header">
        <div className="title">
          {" "}
          {DIALOG_TITLE[sourceType]}{" "}
        </div>
        <div className="description">
          {" "}
          {DIALOG_DESC_SHORT[sourceType]}{" "}
        </div>
      </DialogTitle>
      <DialogContent
        sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
        className="modal-content"
        dividers
      >
        <Box padding={"20px"} className="dialog-header">
          <div style={{ marginBottom: '1rem', fontSize: '15px', textAlign: 'justify' }} >{DIALOG_DESC_LONG[sourceType]}</div>
          <Box sx={{ display: 'flex', gap: '4px', marginBottom: '10px', justifyContent: 'flex-end' }}>
            <LightTooltip title={t('BTN_EXPAND_ALL_ITEMS')}>
              <span>
                <IconButton
                  variant="outlined"
                  onClick={handleExpand}
                  size="small"
                  disabled={!treeData?.length || loading}
                >
                  <KeyboardDoubleArrowDownIcon fontSize="small" />
                </IconButton>
              </span>
            </LightTooltip>
            <LightTooltip title={t('BTN_COLLAPSE_ALL_ITEMS')}>
              <span>
                <IconButton
                  variant="outlined"
                  onClick={handleCollapse}
                  size="small"
                  disabled={!treeData?.length || loading}
                >
                  <KeyboardDoubleArrowUpIcon fontSize="small" />
                </IconButton>
              </span>
            </LightTooltip>
          </Box>
          <Box
            sx={{
              height: "40vh",
              overflowX: "hidden",
              maxHeight: "400px",
              border: "2px solid rgba(0, 0, 0, 0.12)",
              borderRadius: "0.2rem",
              display: loading ? "flex" : "block",
              justifyContent: "center",
              alignItems: "center"
            }}
          >

                         {loading ? <CircularProgress /> : error ? 
               <div className="panel-no-data" style={{ color: 'red' }}> 
                 Error: {error} 
               </div> : treeData?.length ?
               <Tree
                 multiple={selection === "single" ? false : true}
                 treeData={treeData}
                 selectedKeys={selectedKeys}
                 onSelect={onSelect}
                 onExpand={onExpand}
                 expandedKeys={expandedKeys}
                 icon={iconRender}
                 switcherIcon={switcherIcon}
               /> : <div className="panel-no-data"> {t('NO_SESSION_DATA_AVAILABLE')} </div>}
          </Box>
          {showSelection && <Box sx={{ marginTop: "10px" }}>
            {(specialPasswordField && openModal) ? (
              <SmartPasswordField
                onClick={handleTextFieldClick}
                variant="outlined"
                size="small"
                label={t("LBL_VALUE")}
                className={"width-100"}
                name={"TITLE"}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                initialMaskLength={initialMaskLength}
              />
            ) : (
              <FormControl className="width-100" size="small">
                <TextField
                  onClick={handleTextFieldClick}
                  variant="outlined"
                  size="small"
                  label={t("LBL_VALUE")}
                  type={inputType ? inputType : 'text'}
                  className={"width-100"}
                  name={"TITLE"}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />
              </FormControl>
            )}
          </Box>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          disabled={!actions.back}
          variant="outlined"
          color="primary"
          onClick={() => {
            handleClose2(false, sourceType !== "callingWorkflow" ? true : false);
            handleClose1(true);
            setTreeData([]);
          }}
        >
          {" "}
          {t("BTN_BACK")}
        </Button>
        {showSelection && <Button
          size="small"
          disabled={!actions.back || loading}
          variant="outlined"
          color="primary"
          onClick={() => {
            valueHandler(selectedValue, value);
            resetStates();
            handleClose2(false, true);
          }}
        >
          {" "}
          {t("BTN_NEXT")}
        </Button>}
        <Button
          size="small"
          disabled={!actions.finish || loading}
          variant="outlined"
          color="primary"
          onClick={() => {
            valueHandler(selectedValue, value, true);
            resetStates();
            handleClose2(false, false);
          }}
        >
          {" "}
          {t("BTN_FINISH")}
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            resetStates();
            handleClose2(false, true);
          }}
        >
          {" "}
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkflowSessionModal2;
